import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const team = [
  { name: 'Huỳnh Nguyệt Dương', avatar: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/f99133d3b2dccc60e27302f548841130.jpeg' },
  { name: 'Trương Thị Ngọc Trầm', avatar: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/e4f451cd9d66d81997b876d7ed67d8e2.jpeg' },
  { name: 'Nguyễn Hà Ngọc Anh', avatar: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/4c2be9c5c1cd2dee618e4c697e30be10.jpeg' },
  { name: 'Nguyễn Xuân Hương', avatar: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/ab32daa891b4c24b55c38977d0822731.jpeg' },
  { name: 'Tào Nguyệt Ánh', avatar: 'https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/6096929f22e8877eb3d9d7d7c15f3c65.png' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen" style={{ background: '#fdf5e8' }}>
      <Header />

      {/* ===== SECTION 1 — Hero: Warm cream/amber ===== */}
      <section
        className="pt-28 pb-20"
        style={{ background: 'linear-gradient(160deg, #fff8ee 0%, #fdecd0 60%, #fce3b8 100%)' }}
      >
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-orange/15 rounded-full mb-4 border border-primary-orange/25">
              <i className="ri-information-fill text-primary-orange"></i>
              <span className="text-sm font-bold text-primary-orange uppercase tracking-wider">Giới thiệu</span>
            </div>
            <h1 className="text-5xl font-bold text-primary-brown-dark mb-6 leading-tight">
              Túi trò chơi<br />dân gian Bahnar
            </h1>
            <p className="text-xl text-primary-brown leading-relaxed mb-6">
              Nền tảng giáo dục giúp học sinh tiểu học khám phá văn hóa truyền thống của người Bahnar qua những trò chơi dân gian vui nhộn, bổ ích.
            </p>
            <p className="text-base text-primary-brown-light leading-relaxed mb-8">
              Chúng tôi tin rằng văn hóa dân tộc cần được bảo tồn và lan truyền theo cách gần gũi, sinh động nhất - qua những tiếng cười, những trò chơi và những bài học thú vị dành cho trẻ em.
            </p>
            <div className="flex gap-4 flex-wrap">
              <Link to="/games" className="px-8 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-full hover:opacity-90 transition-all cursor-pointer whitespace-nowrap">
                Bắt đầu khám phá
              </Link>
              <Link to="/knowledge" className="px-8 py-3 border-2 border-primary-orange text-primary-orange font-bold rounded-full hover:bg-primary-orange hover:text-white transition-all cursor-pointer whitespace-nowrap">
                Tìm hiểu thêm
              </Link>
            </div>
          </div>
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/d8a14561-881d-44c3-b34b-e20c82ce068c.png"
              alt="Về chúng tôi"
              className="w-full h-96 object-cover object-top rounded-3xl"
            />
          </div>
        </div>
      </section>

      {/* ===== SECTION 3 — Tính năng website: Warm peach/apricot ===== */}
      <section
        className="py-20"
        style={{ background: 'linear-gradient(160deg, #fff3e8 0%, #ffe8cc 50%, #ffddb8 100%)' }}
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-primary-orange/15 rounded-full mb-4 border border-primary-orange/25">
              <div className="w-2 h-2 rounded-full bg-primary-orange"></div>
              <span className="text-sm font-bold text-primary-orange uppercase tracking-widest">Tính năng của website</span>
              <div className="w-2 h-2 rounded-full bg-primary-yellow"></div>
            </div>
            <h2 className="text-4xl font-bold text-primary-brown-dark mb-4">Những gì chúng tôi mang lại</h2>
            <p className="text-lg text-primary-brown-light max-w-xl mx-auto">Mọi thứ bạn cần để học và trải nghiệm văn hóa Bahnar</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/80 rounded-3xl p-10 flex flex-col items-center text-center group hover:scale-105 transition-transform duration-300 border border-primary-orange/10">
              <div className="w-20 h-20 flex items-center justify-center bg-primary-orange/10 rounded-3xl mb-6">
                <i className="ri-shopping-bag-3-fill text-4xl text-primary-orange"></i>
              </div>
              <div className="w-10 h-1 rounded-full bg-primary-orange mb-5"></div>
              <h3 className="text-xl font-bold text-primary-brown-dark mb-3">Túi Trò Chơi</h3>
              <p className="text-primary-brown-light leading-relaxed text-base">
                Kho trò chơi dân gian Bahnar với hướng dẫn chi tiết, chibi dễ thương và những thử thách hấp dẫn.
              </p>
            </div>

            <div className="rounded-3xl p-10 flex flex-col items-center text-center group hover:scale-105 transition-transform duration-300"
              style={{ background: 'linear-gradient(160deg, #d4521a, #f5b942)' }}>
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-3xl mb-6">
                <i className="ri-seedling-fill text-4xl text-white"></i>
              </div>
              <div className="w-10 h-1 rounded-full bg-white/50 mb-5"></div>
              <h3 className="text-xl font-bold text-white mb-3">Hạt Giống Tri Thức</h3>
              <p className="text-white/85 leading-relaxed text-base">
                Thư viện video và hình ảnh về văn hóa, lịch sử và đời sống của người Bahnar.
              </p>
            </div>

            <div className="bg-white/80 rounded-3xl p-10 flex flex-col items-center text-center group hover:scale-105 transition-transform duration-300 border border-green-200">
              <div className="w-20 h-20 flex items-center justify-center bg-green-100 rounded-3xl mb-6">
                <i className="ri-group-fill text-4xl text-green-500"></i>
              </div>
              <div className="w-10 h-1 rounded-full bg-green-400 mb-5"></div>
              <h3 className="text-xl font-bold text-primary-brown-dark mb-3">Cộng Đồng</h3>
              <p className="text-primary-brown-light leading-relaxed text-base">
                Nơi giáo viên, học sinh và phụ huynh chia sẻ trải nghiệm, thành tích và thông tin văn hóa Bahnar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 4 — Sứ mệnh: Lighter orange ===== */}
      <section
        className="py-20"
        style={{ background: 'linear-gradient(160deg, #d4631e, #e8852a 50%, #f5b942)' }}
      >
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-3xl mx-auto mb-6">
            <i className="ri-heart-fill text-white text-3xl"></i>
          </div>
          <h2 className="text-4xl font-bold text-white mb-6">Sứ mệnh của chúng tôi</h2>
          <p className="text-xl text-white/90 leading-relaxed mb-4">
            Bảo tồn và phát huy di sản văn hóa người Bahnar thông qua giáo dục sáng tạo, giúp thế hệ trẻ tự hào về cội nguồn dân tộc và trân trọng những giá trị truyền thống quý báu.
          </p>
          <p className="text-base text-white/75 leading-relaxed">
            Chúng tôi xây dựng cầu nối giữa thế hệ xưa và nay — nơi những trò chơi dân gian không chỉ là giải trí, mà còn là bài học về cuộc sống, về con người và về bản sắc văn hóa Bahnar.
          </p>
        </div>
      </section>

      {/* ===== SECTION 5 — Đội ngũ: Soft golden yellow ===== */}
      <section
        className="py-20"
        style={{ background: 'linear-gradient(160deg, #fffbe8 0%, #fff5c8 50%, #fdf0b0 100%)' }}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-4 border border-yellow-400/40"
              style={{ background: 'rgba(220,170,0,0.12)' }}>
              <i className="ri-team-fill" style={{ color: '#a07800' }}></i>
              <span className="text-sm font-bold uppercase tracking-widest" style={{ color: '#a07800' }}>Đội ngũ</span>
            </div>
            <h2 className="text-4xl font-bold mb-2" style={{ color: '#5a4000' }}>Đội ngũ thực hiện</h2>
            <p className="text-base" style={{ color: '#8a6c10' }}>Những người đã tạo nên Túi trò chơi dân gian Bahnar</p>
          </div>
          <div className="flex flex-wrap justify-center gap-10">
            {team.map(member => (
              <div key={member.name} className="text-center flex flex-col items-center" style={{ width: '200px' }}>
                <img
                  src={member.avatar}
                  alt={member.name}
                  className="w-32 h-32 rounded-full object-cover object-top mx-auto mb-4"
                  style={{ border: '4px solid rgba(220,170,0,0.35)', boxShadow: '0 4px 16px rgba(180,120,0,0.15)' }}
                />
                <h3 className="font-bold text-base" style={{ color: '#5a4000' }}>{member.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
